// For data that changes only when a user edits it. Data that changes on its own
// (clicks, stats, events) uses VOLATILE_QUERY_STALE_TIME_MS.
export const QUERY_STALE_TIME_MS = 5 * 60_000;

export const VOLATILE_QUERY_STALE_TIME_MS = 0;

// The experiment stats are among the heaviest reads, and a minute-old count
// is still a fair one. Edits that move the numbers invalidate them at once.
export const EXPERIMENT_STATS_STALE_TIME_MS = 60_000;
